import React from "react";
import { checkmarkgreen } from "../../common/svg";
import { MultiSelectProps, Option } from "../../service/interfaces/Components";
import SecureImage from "../../components/BucketImage/Image";

const MultiSelect: React.FC<MultiSelectProps> = ({
  options,
  selectedOptions,
  onChange,
  label,
  isDisabled,
  isMultiSelect,
}) => {
  const handleSelect = (option: Option) => {
    if (isDisabled) return; // Prevent interaction if disabled

    const isSelected = selectedOptions.some(
      (selected) => selected.value === option.value
    );

    let updatedSelections;
    if (isMultiSelect) {
      updatedSelections = isSelected
        ? selectedOptions.filter((selected) => selected.value !== option.value) // Remove from selected
        : [...selectedOptions, option]; // Add to selected
    } else {
      updatedSelections = isSelected ? [] : [option]; // Toggle single selection
    }

    onChange(updatedSelections);
  };

  return (
    <div className="multi-select">
      <p className="ml-8 mb-1 text-[14px]">{label}</p>
      <div
        className={`grid grid-cols-2 gap-2 ${
          isDisabled ? "opacity-50 cursor-not-allowed" : ""
        }`}
      >
        {options.map((option) => {
          const isSelected = selectedOptions.some(
            (selected) => selected.value === option.value
          );
          return (
            <div
              key={option.value}
              className={`multi-select-option ${isSelected ? "selected" : ""}`}
              onClick={() => handleSelect(option)}
              style={{
                display: "flex",
                alignItems: "center",
                cursor: isDisabled ? "not-allowed" : "pointer",
              }}
            >
              {/* Checkmark */}
              {isSelected ? (
                checkmarkgreen?
                <SecureImage
                  fileKey={checkmarkgreen}
                  alt="check"
                  width="35px"
                />:null
              ) : (
                <div
                  className={`tick-box`}
                  style={{
                    width: "38px",
                    height: "38px",
                    borderRadius: "4px",
                    backgroundColor: "transparent",
                  }}
                />
              )}

              {/* Input Field */}
              <input
                type="text"
                value={option.label}
                readOnly
                className="placeholder-[#8897AD] text-[14px] h-[35.8px] font-[400] leading-[20.64px] text-[#333]"
                style={{
                  background: "transparent",
                  color: "#000",
                  pointerEvents: "none", // Prevent input focus
                  border: "1px solid  #D1D5DB",
                  outline: "none",
                  lineHeight: "0.25rem",
                  backgroundColor: isSelected ? "#ECFFEB" : "#F7FBFF",
                  letterSpacing: "1%",
                  width: "100%",
                  padding: "10px 12px",
                  borderRadius: "10.48px",
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MultiSelect;
